export default {
  path: '/verticales',
  name: 'verticales',
  component: () => import('../components/verticale/Layout'),
  redirect: { name: 'VerticaleList' },
  meta: {
    breadcrumb: 'verticale.verticales',
  },
  children: [
    {
      name: 'VerticaleList',
      path: '',
      component: () => import('../views/verticale/List'),
      meta: {
        breadcrumb: 'global.list',
      },
    },
    {
      name: 'VerticaleCreate',
      path: 'new',
      component: () => import('../views/verticale/Create'),
      meta: {
        breadcrumb: 'global.add',
      },
    },
    {
      name: 'VerticaleUpdate',
      path: ':id/edit',
      component: () => import('../views/verticale/Update'),
      meta: {
        breadcrumb: 'verticale.verticale',
      },
    },
    {
      name: 'VerticaleShow',
      path: ':id',
      component: () => import('../views/verticale/Show'),
      meta: {
        breadcrumb: 'verticale.verticale',
      },
    }
  ]
};
